namespace Solovis.Portal.TxServices {

    /**
     * TxCachedExchangeRateManager manages the set of exchange rate scalars retrieved from the server.
     */
    export class TxCachedExchangeRateManager {

        private _portalServices: Solovis.Portal.IPortalServices;

        public _keyToHolderMap;

        constructor(options?: {
            portalServices?: Solovis.Portal.IPortalServices;
        }) {

            if (options && options.portalServices) {
                this._portalServices = options.portalServices;
            }
            else {
                this._portalServices = new Solovis.Portal.SitePortalServices();
            }

            this._keyToHolderMap = {};
        }

        public _getScalarKey(dayId, sourceCurrencyId, targetCurrencyId) {
            return "" + dayId + "-" + sourceCurrencyId + "-" + targetCurrencyId;
        }

        public registerScalarData(scalarData) {
            var key = this._getScalarKey(scalarData.dayId, scalarData.sourceCurrencyId, scalarData.targetCurrencyId);

            var holder = this._keyToHolderMap[key];
            if (!holder) {
                holder = {};
                this._keyToHolderMap[key] = holder;
            }

            holder.scalarData = scalarData;

            if (holder.callbacks) {
                $(holder.callbacks).each(function (i, callback: any) {
                    try {
                        callback(holder.scalarData);
                    }
                    catch (ex) {
                        console.log("TxCachedExchangeRateManager callback error");
                        console.log(ex);
                    }
                });
            }
        }

        /*
         * getScalarDataAsync will request the scalarData and callback(scalarData) will be called with the result.
         */
        public getScalarDataAsync(dayId, sourceCurrencyId, targetCurrencyId, callback) {
            var self = this;

            var key = this._getScalarKey(dayId, sourceCurrencyId, targetCurrencyId);

            var holder = this._keyToHolderMap[key];
            if (!holder) {
                holder = {
                    dayId: dayId,
                    sourceCurrencyId: sourceCurrencyId,
                    targetCurrencyId: targetCurrencyId
                };
                this._keyToHolderMap[key] = holder;
            }

            if (holder.scalarData) {
                callback(holder.scalarData);
            }
            else {
                if (!holder.callbacks) {
                    holder.callbacks = [];
                }

                holder.callbacks.push(callback);

                if (!holder.loadPending) {
                    holder.loadPending = true;

                    this._portalServices.rpc().invoke(
                        "~/DataManagement/TransactionEditor/GetForexConversionScalar",
                        {
                            dayId: dayId,
                            sourceCurrencyId: sourceCurrencyId,
                            targetCurrencyId: targetCurrencyId
                        },
                        function (response, success) {
                            holder.loadPending = false;

                            if (success) {
                                self.registerScalarData(response.result);
                            }
                        });
                }
            }
        }
    }

}
